export default "__VITE_ASSET__B8LUW$5g__"